var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.closeState,
      expression: "!closeState"
    }]
  }, [_c('div', {
    staticClass: "musk"
  }), _vm._v(" "), _c('div', {
    staticClass: "right-menu animated",
    class: {
      bounceInRight: _vm.closeState == false
    }
  }, [_c('div', {
    staticClass: "close",
    class: {
      'closeani': _vm.closeState
    },
    on: {
      "click": function click($event) {
        return _vm.close();
      }
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "main-title-container"
  }, [_c('li', {
    class: {
      'current': _vm.showState == '1'
    },
    on: {
      "click": function click($event) {
        return _vm.showItem('1');
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("menu.company")))]), _vm._v(" "), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showState == '1',
      expression: "showState == '1'"
    }],
    staticClass: "sub-title-container bottom-state"
  }, [_c('li', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/protocol/about.html"
    },
    on: {
      "click": function click($event) {
        return _vm.KEWLSensorTrack('/protocol/about.html');
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("menu.about")))])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/protocol/contact.html"
    },
    on: {
      "click": function click($event) {
        return _vm.KEWLSensorTrack('/protocol/contact.html');
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("menu.contact")))])])])]), _vm._v(" "), _c('li', {
    class: {
      'current': _vm.showState == '2'
    },
    on: {
      "click": function click($event) {
        return _vm.showItem('2');
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("menu.law")))]), _vm._v(" "), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showState == '2',
      expression: "showState == '2'"
    }],
    staticClass: "sub-title-container bottom-state"
  }, [_c('li', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/protocol/community_policy.html"
    },
    on: {
      "click": function click($event) {
        return _vm.KEWLSensorTrack('/protocol/community_policy.html');
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("menu.community")))])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/protocol/terms.html"
    },
    on: {
      "click": function click($event) {
        return _vm.KEWLSensorTrack('/protocol/terms.html');
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("menu.terms")))])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/protocol/privacy.html"
    },
    on: {
      "click": function click($event) {
        return _vm.KEWLSensorTrack('/protocol/privacy.html');
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("menu.privacy")))])])])]), _vm._v(" "), _c('li', {
    class: {
      'current': _vm.showState == '3'
    },
    on: {
      "click": function click($event) {
        return _vm.showItem('3');
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("menu.security")))]), _vm._v(" "), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showState == '3',
      expression: "showState == '3'"
    }],
    staticClass: "sub-title-container bottom-state"
  }, [_c('li', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/protocol/safetyadvocateapplicant.html"
    },
    on: {
      "click": function click($event) {
        return _vm.KEWLSensorTrack('/protocol/safetyadvocateapplicant.html');
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("menu.advocates")))])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/protocol/protection.html"
    },
    on: {
      "click": function click($event) {
        return _vm.KEWLSensorTrack('/protocol/protection.html');
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("menu.userprotection")))])])])])]), _vm._v(" "), _c('ul', {
    staticClass: "sub-title-container right-state"
  }, [_c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showState == '1',
      expression: "showState == '1'"
    }]
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/protocol/about.html"
    },
    on: {
      "click": function click($event) {
        return _vm.KEWLSensorTrack('/protocol/about.html');
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("menu.about")))])]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showState == '1',
      expression: "showState == '1'"
    }]
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/protocol/contact.html"
    },
    on: {
      "click": function click($event) {
        return _vm.KEWLSensorTrack('/protocol/contact.html');
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("menu.contact")))])]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showState == '2',
      expression: "showState == '2'"
    }]
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/protocol/community_policy.html"
    },
    on: {
      "click": function click($event) {
        return _vm.KEWLSensorTrack('/protocol/community_policy.html');
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("menu.community")))])]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showState == '2',
      expression: "showState == '2'"
    }]
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/protocol/terms.html"
    },
    on: {
      "click": function click($event) {
        return _vm.KEWLSensorTrack('/protocol/terms.html');
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("menu.terms")))])]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showState == '2',
      expression: "showState == '2'"
    }]
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/protocol/privacy.html"
    },
    on: {
      "click": function click($event) {
        return _vm.KEWLSensorTrack('/protocol/privacy.html');
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("menu.privacy")))])]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showState == '3',
      expression: "showState == '3'"
    }]
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/protocol/safetyadvocateapplicant.html"
    },
    on: {
      "click": function click($event) {
        return _vm.KEWLSensorTrack('/protocol/safetyadvocateapplicant.html');
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("menu.advocates")))])]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showState == '3',
      expression: "showState == '3'"
    }]
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/protocol/protection.html"
    },
    on: {
      "click": function click($event) {
        return _vm.KEWLSensorTrack('/protocol/protection.html');
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("menu.userprotection")))])])]), _vm._v(" "), _c('div', {
    staticClass: "popular"
  }, [_c('ul', [_c('li', {
    on: {
      "click": function click($event) {
        return _vm.goPopular();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("explorePage")))])])])])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };